/**
 * @class LicenseContactPerson
 */
export default class LicenseContactPerson {
    /**
     * @param {String} name
     * @param {String} email
     * @param {String} phone
     */
    constructor(name = "", email = "", phone = "") {
        this._name = name;
        this._phone = phone;
        this._email = email;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get phone() {
        return this._phone;
    }

    /**
     * @param {String} phone
     */
    set phone(phone) {
        this._phone = phone;
    }

    /**
     * @return {String}
     */
    get email() {
        return this._email;
    }

    /**
     * @param {String} email
     */
    set email(email) {
        this._email = email;
    }
}
